<template>
  <div class="py-3">
    <CardWithCloseButton @onClose="$emit('onClose')">
      <div class="px-5 py-3">
        <div class="flex justify-between items-center">
          <p class="text-sm font-bold text-greenPrimary">Detail Feature</p>
          <SearchInput id="feature" @input="search" />
        </div>

        <div
          class="overflow-x-auto relative rounded-lg pt-3"
          v-if="!features.loading"
        >
          <table class="w-full text-sm text-gray-500 mb-3">
            <thead>
              <tr class="bg-gray-200">
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  #
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Feature ID
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Kode Petak
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  No Kontrak
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Luas (HA)
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Nama Kebun
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Nama Petani
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-white text-left"
                v-for="(item, index) in features.rows"
                :key="index"
              >
                <td class="py-3 px-3 border border-gray-300 text-center">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-3 px-3 border border-gray-300">
                  {{ item.properties.feature_id }}
                </td>
                <td class="py-3 px-3 border border-gray-300 text-right">
                  {{ item.properties.kode_petak }}
                </td>
                <td class="py-3 px-3 border border-gray-300">
                  {{ item.properties.no_kontrak }}
                </td>
                <td class="py-3 px-3 border border-gray-300 text-right">
                  {{ item.properties.luasha }}
                </td>
                <td class="py-3 px-3 border border-gray-300">
                  {{ item.properties.namakebun }}
                </td>
                <td class="py-3 px-3 border border-gray-300">
                  {{ item.properties.namapetani }}
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>

        <LoadingLottie v-if="features.loading" />
        <AlertErrorComponent
          v-if="features.error"
          :message="features.error.response.data.message"
        />
        <div class="flex justify-center" v-if="features.rows?.length == 0">
          <NoData size="w-full md:w-5/12" />
        </div>
      </div>
    </CardWithCloseButton>
  </div>
</template>
<script>
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import CardWithCloseButton from "@/components/CardWithCloseButton.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import SearchInput from "@/components/SearchInput.vue";
import { useSceneStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    CardWithCloseButton,
    PaginationComponent,
    LoadingLottie,
    AlertErrorComponent,
    NoData,
    SearchInput,
  },
  setup() {
    const sceneStore = useSceneStore();
    const { features } = storeToRefs(sceneStore);

    const limit = ref(25);
    const offset = ref(0);
    const length = ref(0);
    const page = ref(1);
    const q = ref(null);

    const getDetail = async () => {
      await sceneStore.getAllSgnksofeatures({
        limit: limit.value,
        offset: offset.value,
      });
      length.value = features.value.count;
    };

    onMounted(() => {
      getDetail();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { limit: limit.value, offset: offset.value };
      if (q.value != null || q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }
      await sceneStore.getAllSgnksofeatures(dataparams);
      length.value = features.value.count;
    };

    const search = async (event) => {
      offset.value = 0;
      page.value = 1;
      q.value = event.target.value;

      await sceneStore.getAllSgnksofeatures({
        limit: limit.value,
        offset: offset.value,
        q: event.target.value,
      });
      length.value = features.value.count;
    };

    return {
      features,
      limit,
      page,
      length,
      changePage,
      search,
    };
  },
};
</script>
<style></style>
